import SearchCombobox from './SearchCombobox';

export { type SearchComboboxProps } from './SearchCombobox';
export default SearchCombobox;
